import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { Worker } from '@react-pdf-viewer/core';
import { saveAs } from 'file-saver';
import { CloseIcon } from '../assets/svgImages';
import { nativeService } from '../helpers/nativeService';
import { useContext } from 'react';
import { UserContext } from '../context/userContext';
import { NativeResponseType } from '../interface/native.interface';

export const PdfPreview = ({
  previewUrl,
  profileName,
  closePreview,
  previewBlob,
  needDownload = true,
}: any) => {
  const { nativeView, isMobile } = useContext(UserContext);

  const saveDosageDiary = () => {
    if (nativeView) {
      const reader = new FileReader();
      reader.onloadend = function () {
        let base64data = '';
        if (typeof reader.result === 'string') {
          base64data = reader.result.split(',')[1];
        }
        nativeService(
          JSON.stringify({
            type: NativeResponseType.DOWNLOAD_BLOB,
            filename: 'dosagediary.pdf',
            base64: base64data,
          }),
        );
      };
      reader.readAsDataURL(previewBlob);
      return;
    }
    saveAs(previewBlob, 'dosagediary.pdf');
  };

  return (
    <Worker workerUrl="/pdf.worker.min.js">
      {previewUrl && (
        <div className="fixed inset-0 bg-opacity-70 flex items-center justify-center z-[1000] backdrop-brightness-[0.5]">
          <div className="bg-white rounded-lg shadow-lg w-[95%] md:w-[80%] lg:w-[60%] max-h-[80vh] flex flex-col">
            <div className="flex justify-between items-center p-3 bg-primary-blue-500 text-white font-semibold rounded-t-lg">
              <h2>{profileName}</h2>
              <div className="flex items-center">
                {needDownload ? (
                  <div className="hidden md:block">
                    <button
                      className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md shadow-sm bg-white text-primary-blue-500 hover:bg-cornflowerblue-700"
                      onClick={() => {
                        saveAs(previewBlob, `${profileName}.pdf`);
                        closePreview();
                      }}
                    >
                      Download
                    </button>
                  </div>
                ) : (
                  <></>
                )}
                <CloseIcon
                  onClick={closePreview}
                  className="cursor-pointer fill-white w-5 h-5 ms-3"
                />
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-2">
              <Viewer
                fileUrl={previewUrl}
                defaultScale={isMobile || nativeView ? 0.5 : 1}
              />
            </div>

            {needDownload ? (
              <div className="p-4 flex justify-end bg-white shadow rounded-b-lg md:hidden">
                <button
                  className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md shadow-sm text-white bg-secondary-cornflowerblue-600 hover:bg-cornflowerblue-700"
                  onClick={() => {
                    saveDosageDiary();
                    closePreview();
                  }}
                >
                  Download
                </button>
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </Worker>
  );
};
